import React from 'react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-135" data-mp="17xuswfmwwmsb">
      <div className="mx-auto max-w-md" data-id="element-136" data-mp="1mo2182j7gpfa">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-137" data-mp="1mmqz075erpqa">
          <span aria-hidden="true" data-id="element-138" data-mp="tyv5tcf1sfy9">🏆 </span>Special Launch Offer
        </h2>

        <div className="relative mt-10 rounded-3xl border-2 border-brand bg-white px-7 pb-8 pt-11 shadow-soft" data-id="element-139" data-mp="u0xsbmgzrqy8">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-brand px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-140" data-mp="p24ratiw5sey">
            English Ready™ Pack
          </span>

          <dl data-id="element-141" data-mp="2fbxxj64v4fbj">
            {offerRows.map(row => <div key={row.label} className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-142" data-mp="2fad2zgijswdo">
                <dt className="text-ink/80" data-id="element-143" data-mp="pj5s0gnh24ab">{row.label}</dt>
                <dd className="font-bold text-brand" data-id="element-144" data-mp="ujboqb8lmgz9">{row.value}</dd>
              </div>)}
            <div className="flex items-center justify-between border-b border-ink/10 py-4 text-sm" data-id="element-145" data-mp="zietduko2l6p">
              <dt className="font-bold uppercase tracking-wide text-ink" data-id="element-146" data-mp="13k000y6ly38g">
                Total Value:
              </dt>
              <dd className="font-bold text-amber-600 line-through" data-id="element-147" data-mp="6uio41h17kyb">
                $212 USD
              </dd>
            </div>
          </dl>

          <p className="mt-6 text-center text-[11px] font-extrabold uppercase tracking-[0.16em] text-brand" data-id="element-148" data-mp="bt2au43g90rq">
            Today
          </p>
          <p className="flex items-center justify-center gap-2 border-b border-ink/10 pb-7 pt-2" data-id="element-149" data-mp="kkvysblb5drc">
            <span className="text-4xl leading-none" aria-hidden="true" data-id="element-150" data-mp="3k8vvmv4tcyel">
              🏆
            </span>
            <span className="font-display text-6xl font-black leading-none text-brand" data-id="element-151" data-mp="3o9pdp7vkrizk">
              $27
            </span>
            <span className="self-end pb-2 text-sm font-bold text-brand" data-id="element-152" data-mp="vefta29km513">
              USD
            </span>
          </p>

          <CtaButton className="mt-7 w-full" data-id="element-153" data-mp="qge1msy2wxe0" />

          <p className="mt-4 text-center text-[11px] font-medium text-ink/50" data-id="element-154" data-mp="156243xhzy23b">
            Instant Download · One-Time Payment · Lifetime Access · 7-Day
            Guarantee
          </p>
        </div>
      </div>
    </section>;
}